import type { CommentResponse } from '../types';

export const countComments = (comments: CommentResponse[] = []): number => {
  return comments.length + comments.reduce((acc, curr) => {

    acc += curr.replies ?? 0;
    return acc;

  }, 0);
};